import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
// import {
//   getPolygonStrFromFeature,
//   circleStrToFlatArray,
//   polygonStrToArray,
// } from 'Utils/mapUtils'
import Collapsible from 'Components/Collapsible'
import ShowOnVisible from 'Components/ShowOnVisible'
// import MapSearchButton from 'Components/MapSearchButton'

import { ComparablePreviews } from './components'
import { useFetchComparableArchivedListings } from './comparableArchivedListingsApis'
// import css from './styles.js'
import {
  _MapPreviewsContainer, collapseContainerCss,
  _MapSearchButton, _Text, collapseContentCss, _NoListings,
} from './styles'


const ComparableArchivedListings = ({
  latitude,
  longitude,
  listing,
  offer,
  seoText,
  // collapsibleIdSuffix,
  isMobileApp,
  mobileBrowser,
  googleAnalyticsEvent,
  userIsAuthentificated,
  source,
  withoutCollapsibale,
  lowestAreaUrl,
}) => {
  if(!latitude || !longitude) return null

  const startDateUnix = useMemo(() => {
    const currentDate = new Date()
    const startDate = new Date()
    startDate.setFullYear(currentDate.getFullYear() - 1)

    return Math.floor(startDate.getTime() / 1000)
  }, [])

  const listingWithLatLng = listing.address ? listing :
    {
      ...listing,
      address: {
        lat: latitude,
        lng: longitude,
      },
    }

  const { data: comparableListings } = useFetchComparableArchivedListings({
    listing: listingWithLatLng,
    offer,
    startDateUnix,
  })
  const propertyType = listing?.property_type || listing?.subtype

  const SearchButton = false && !isMobileApp && (
    <_MapSearchButton
      url={lowestAreaUrl}
      lng={longitude}
      lat={latitude}
      target={mobileBrowser ? '_self' : '_blank'}
      googleAnalyticsEvent={googleAnalyticsEvent}
      offer={offer}
      mode={offer === 'Sale' ? 'Sold' : 'Leased'}
      propertyType={propertyType}
    >
      <_Text>
        {`View comparable ${offer?.toLowerCase()}s`}
      </_Text>
    </_MapSearchButton>
  )

  const children = (
    <ShowOnVisible offset={{ bottom: -400 }}>
      <_MapPreviewsContainer>
        <ComparablePreviews
          userIsAuthentificated={userIsAuthentificated}
          listings={comparableListings}
          source={source}
          estimateListing={listingWithLatLng}
        />
        {
          comparableListings?.length === 0 && (
            <_NoListings>
              There are currently no active listings in this area
            </_NoListings>
          )
        }

        {SearchButton}
      </_MapPreviewsContainer>
    </ShowOnVisible>
  )

  if(withoutCollapsibale) return children

  return (
    <Collapsible
      inputId={`Comparable ${offer}s`}
      title={`Comparable ${offer}s`}
      seoText={seoText}
      customClasses={{
        collapseContainer: collapseContainerCss,
        collapseContent: collapseContentCss,
      }}
      defaultShowState
    >
      {children}
    </Collapsible>
  )
}

ComparableArchivedListings.propTypes = {
  address: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
    formatted: PropTypes.string,
    map_files: PropTypes.arrayOf(
      PropTypes.shape({
        lowres_path: PropTypes.string,
        normal_path: PropTypes.string,
        thumb_path: PropTypes.string,
        type: PropTypes.string,
      }),
    ),
    url: PropTypes.string,
  }),

  userIsAuthentificated: PropTypes.bool,
  offer: PropTypes.string,
  seoText: PropTypes.string,
  googleAnalyticsEvent: PropTypes.func,
  source: PropTypes.string,
  mobileBrowser: PropTypes.bool,
  // collapsibleIdSuffix: PropTypes.string,
  isMobileApp: PropTypes.bool,
  withoutCollapsibale: PropTypes.bool,

  latitude: PropTypes.number,
  longitude: PropTypes.number,
  listing: PropTypes.shape({
    address: PropTypes.shape({}),
    property_type: PropTypes.string,
    subtype: PropTypes.string,
  }),
  lowestAreaUrl: PropTypes.string,
}

export default ComparableArchivedListings
